import { SetFilterValuesFuncParams } from "ag-grid-enterprise";
import React from "react";
import { Report, TicketRedemption } from "types";
import { redemptionAppApi } from "../../../../api/redemptionAppApi";
import { UserRenderer } from "../ColumnTypes";
import { CustomReport } from "../CustomReport";
import { ReportColumnDef, ReportColumnFilterValueType } from "../SuggestedReports";
import { getAllTicketRedemptionStatus, getTicketRedemptionStatus } from "./TicketRedemptionStatus";

export const TicketRedemptionReport = ({ report }: { report: Report }) => {
    const columns = React.useMemo(
        () =>
            getColumnDefs({
                report,
            }),
        [report],
    );
    return <CustomReport dateFields={["createdAt"]} report={report} columns={columns} apiClient={redemptionAppApi} />;
};

type GetColumnDefsParams = {
    report: Report;
};
const getColumnDefs = ({ report }: GetColumnDefsParams): ReportColumnDef[] => [
    {
        field: "order",
        headerName: "Purchase ID",
        type: ["objectid", "purchase"],
        filter: true,
    },
    {
        field: "confirmationCode",
        headerName: "Confirmation Code",
        minWidth: 200,
    },
    {
        field: "item",
        headerName: "Item ID",
        type: ["objectid"],
        filter: true,
        minWidth: 200,
    },
    {
        field: "experience",
        headerName: "Listing",
        type: "product",
        filter: true,
        maxWidth: 250,
    },
    {
        field: "guest",
        headerName: "Guest ID",
        type: ["objectid"],
        filter: true,
        minWidth: 200,
    },
    {
        field: "user",
        headerName: "Location",
        cellRenderer: UserRenderer,
        filterParams: {
            cellRenderer: UserRenderer,
        },
        filter: true,
        minWidth: 200,
    },
    {
        field: "status",
        width: 200,
        headerName: "Status",
        filter: "agSetColumnFilter",
        filterParams: {
            values: (params: SetFilterValuesFuncParams) => {
                const statuses = getAllTicketRedemptionStatus();
                params.success(statuses.map((status) => status.key));
            },
            cellRenderer: ({ value }: { value: string }) => {
                return getTicketRedemptionStatus(value);
            },
        },
        cellRenderer: ({ value }: { value: string }) => {
            return getTicketRedemptionStatus(value);
        },
    },
    {
        field: "createdAt",
        headerName: "Created Date",
        type: "datetime",
        filterValueType: ReportColumnFilterValueType.DATE,
        filterParams: {
            report,
        },
    },
    {
        field: "forceCheckin",
        headerName: "Forced Check-In",
        valueGetter: ({ data }: { data: TicketRedemption }) => {
            return data.forceCheckin ? "Yes" : "No";
        },
    },
];
